import React from 'react';
import ConstructionOutlinedIcon from '@mui/icons-material/ConstructionOutlined';
import PageContainer from '../../components/PageContainer';
import { EmptyState, PageHeader, Panel } from '../../components/ui';

/** Placeholder for routes that exist in the menu but have no screen yet (Products, Companies). */
const ComingSoon = () => (
    <PageContainer constrained>
        <PageHeader eyebrow="API Integration" title="Coming soon" />
        <Panel>
            <EmptyState
                icon={<ConstructionOutlinedIcon />}
                title="This page is not built yet"
                hint="It is on the roadmap; until then the data lives in the order service directly."
            />
        </Panel>
    </PageContainer>
);

export default ComingSoon;
